export default {
  campaign: undefined,
  valid_from: undefined,
  valid_until: undefined,
  validate: undefined,
  posterId: undefined,
  allPlacesSelected: false,
  childSelected: [],
  promotionsCampaigns: [],
  postersSelected: [],
  hasExpiration: true,
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/release-posters/state.js